import { render } from "./addSupply.vue?vue&type=template&id=443cfac6&scoped=true"
import script from "./addSupply.vue?vue&type=script&lang=js"
export * from "./addSupply.vue?vue&type=script&lang=js"

import "./addSupply.vue?vue&type=style&index=0&id=443cfac6&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443cfac6"]])

export default __exports__